import {IconList, IconMap} from '@travel-frontend/icons';
import {Button as ButtonUI} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {Container} from '@/modules/common/components/MapTrigger/components/Container';

type Props = {
  mapView: boolean;
  openMapView: () => void;
  closeMapView: () => void;
};

export const MapTrigger = ({mapView, openMapView, closeMapView}: Props) => {
  const {t} = useTranslation('hotels');

  return (
    <Container mapView={mapView}>
      <ButtonUI
        variant="neutral"
        onClick={mapView ? closeMapView : openMapView}
        icon={mapView ? <IconList /> : <IconMap />}
      >
        {mapView
          ? t('mapView.backToHotelsButton.label')
          : t('floatingMapButton.label')}
      </ButtonUI>
    </Container>
  );
};
